import React, { createContext, useContext, useReducer, useRef } from 'react';

const ChatContext = createContext();

const initialState = {
  messages: [{
    id: Date.now(),
    position: 'left',
    type: 'text',
    text: 'Hello! I\'m BeachBot, your virtual assistant. I\'m here to help you find information, answers and services quickly. Just ask me a question, and let\'s get you the support you need. ',
    date: new Date(),
    isBot: true,
    isGreeting: true,
    feedback: null,
  }],
  input: '',
  commentBoxId: null,
  commentText: '',
  showDownloadDialog: false,
  isDownloading: false,
  isStreaming: false,
  isConnected: false,
};

const chatReducer = (state, action) => {
  switch (action.type) {
    case 'SET_MESSAGES':
      return { ...state, messages: action.payload };
    case 'ADD_MESSAGE':
      return { ...state, messages: [...state.messages, action.payload] };
    case 'UPDATE_LAST_MESSAGE':
      const updatedMessages = [...state.messages];
      const lastIndex = updatedMessages.length - 1;
      if (lastIndex >= 0) {
        if (typeof action.payload === 'function') {
          updatedMessages[lastIndex] = action.payload(updatedMessages[lastIndex]);
        } else {
          updatedMessages[lastIndex] = { ...updatedMessages[lastIndex], ...action.payload };
        }
      }
      return { ...state, messages: updatedMessages };
    case 'UPDATE_MESSAGE_BY_ID':
      return {
        ...state,
        messages: state.messages.map(msg =>
          msg.id === action.payload.id ? { ...msg, ...action.payload.updates } : msg
        )
      };
    case 'SET_INPUT':
      return { ...state, input: action.payload };
    case 'SET_COMMENT_BOX_ID':
      return { ...state, commentBoxId: action.payload };
    case 'SET_COMMENT_TEXT':
      return { ...state, commentText: action.payload };
    case 'SET_SHOW_DOWNLOAD_DIALOG':
      return { ...state, showDownloadDialog: action.payload };
    case 'SET_IS_DOWNLOADING':
      return { ...state, isDownloading: action.payload };
    case 'SET_IS_STREAMING':
      return { ...state, isStreaming: action.payload };
    case 'SET_IS_CONNECTED':
      return { ...state, isConnected: action.payload };
    case 'RESET_CHAT':
      return {
        ...initialState,
        messages: [{
          id: Date.now(),
          position: 'left',
          type: 'text',
          text: 'Hello! I\'m BeachBot, your virtual assistant. I\'m here to help you find information, answers and services quickly. Just ask me a question, and let\'s get you the support you need. ',
          date: new Date(),
          isBot: true,
          isGreeting: true,
          feedback: null,
        }]
      };
    default:
      return state;
  }
};

export const ChatProvider = ({ children }) => {
  const [state, dispatch] = useReducer(chatReducer, initialState);
  const sessionIdRef = useRef(`session-${Date.now()}`);
  const wsRef = useRef(null);
  const currentBotMessageRef = useRef(null);
  const currentRequestIdRef = useRef(null);
  const pendingCitationsRef = useRef([]);

  const value = {
    ...state,
    dispatch,
    sessionIdRef,
    wsRef,
    currentBotMessageRef,
    currentRequestIdRef,
    pendingCitationsRef,
  };

  return (
    <ChatContext.Provider value={value}>
      {children}
    </ChatContext.Provider>
  );
};

export const useChatContext = () => {
  const context = useContext(ChatContext);
  if (!context) {
    throw new Error('useChatContext must be used within a ChatProvider');
  }
  return context;
};